import { HelpCircle } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { cn } from '@/lib/utils'

interface HelpPopoverProps {
  /** Short plain-English explanation shown when the user taps the "?" pill. */
  children: React.ReactNode
  /** Accessible label for screen readers. */
  label?: string
  className?: string
}

/**
 * A small "?" pill that, on tap, opens a one-sentence plain-English
 * explanation of a nearby term. Designed for cashiers who don't know
 * what words like "expected cash" or "difference" mean.
 */
export function HelpPopover({ children, label = 'Help', className }: HelpPopoverProps) {
  return (
    <Popover>
      <PopoverTrigger
        type="button"
        aria-label={label}
        className={cn(
          'inline-flex h-6 w-6 items-center justify-center rounded-full border bg-background',
          'text-muted-foreground hover:text-foreground hover:bg-muted',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          'align-middle',
          className,
        )}
      >
        <HelpCircle className="h-3.5 w-3.5" aria-hidden="true" />
      </PopoverTrigger>
      <PopoverContent className="w-64 text-sm leading-relaxed">{children}</PopoverContent>
    </Popover>
  )
}
